export enum MyPhysiciansColumn {
  PhysicianName = 'Physician name',
  Email = 'Email'
}
